import { Permissions } from '@billda/permissions-ui';

export interface SettingsArea {
  id: string;
  label: string;
  path: string;
  testId: string;
  permission?: string;
}

export const DEFAULT_AREA = 'general';

export const settingsAreas: SettingsArea[] = [
  {
    id: 'general',
    label: 'General',
    path: '/settings/general',
    testId: 'settings-nav-general',
  },
  {
    id: 'organisation',
    label: 'Organisation',
    path: '/settings/organisation',
    testId: 'settings-nav-organisation',
    permission: Permissions.Organisation.Details.Read,
  },
  {
    id: 'auto-submit',
    label: 'Auto-submit',
    path: '/settings/auto-submit',
    testId: 'settings-nav-auto-submit',
    permission: Permissions.Organisation.Read,
  },
  {
    id: 'late-submission',
    label: 'Late submission',
    path: '/settings/late-submission',
    testId: 'settings-nav-late-submission',
    permission: Permissions.Organisation.Read,
  },
  {
    id: 'security',
    label: 'Security',
    path: '/settings/security',
    testId: 'settings-nav-security',
  },
];

export const visibleAreas = (
  hasPermission: (permission: string) => boolean
): SettingsArea[] =>
  settingsAreas.filter(
    area => !area.permission || hasPermission(area.permission)
  );
